import { specialEventTypes } from '../classes/RecordNode';

export const getEventTypeClassification = (eventType: string) => {
  let eventTypeClassification = 'others';
  if (specialEventTypes.includes(eventType)) {
    eventTypeClassification = eventType;
  }
  return eventTypeClassification;
};
